var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypescriptExtension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2em",
    height: "1.2em",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.172 14.841a1.13 1.13 0 0 0 .401.823q.193.162.478.252q.283.091.665.091q.507 0 .858-.158q.354-.158.54-.44a1.17 1.17 0 0 0 .187-.656q0-.336-.135-.56a1 1 0 0 0-.375-.357a2 2 0 0 0-.566-.21l-.62-.144a1 1 0 0 1-.405-.176a.37.37 0 0 1-.144-.299q0-.234.185-.384q.188-.152.513-.152q.213 0 .369.068a.6.6 0 0 1 .246.181a.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566a1.2 1.2 0 0 0-.5-.41a1.8 1.8 0 0 0-.78-.152q-.438 0-.776.15q-.336.149-.527.421q-.19.273-.19.639q0 .302.122.524q.124.223.352.367q.228.143.54.213l.617.144q.311.073.463.193a.39.39 0 0 1 .152.326a.5.5 0 0 1-.084.29a.56.56 0 0 1-.255.193a1.1 1.1 0 0 1-.413.07q-.177 0-.32-.04a.8.8 0 0 1-.249-.115a.58.58 0 0 1-.255-.384zm-1.244 1.09v-3.337h1.136v-.662H0v.662h1.134v3.337zm7.076-3.999h.893l-1.274 2.007l1.254 1.992h-.909l-.85-1.415h-.034l-.853 1.415H6.37l1.239-2.016l-1.228-1.983h.932l.832 1.438h.035z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescriptExtension);
export default __webpack_public_path__ + "static/media/typescript-extension.dedbe4344bbe681076bbc70ede0fa121.svg";
export { ForwardRef as ReactComponent };